import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { ChevronDown } from 'lucide-react'
import { User } from '@supabase/supabase-js'

interface UserDropdownMenuProps {
  user: User
  userDisplayName: string
  isAdmin: boolean
  onNavigateToProfile: () => void
  onNavigateToDashboard: () => void
  onLogout: () => void
}

/**
 * User dropdown menu component for authenticated users
 */
export function UserDropdownMenu({
  user,
  userDisplayName,
  isAdmin,
  onNavigateToProfile,
  onNavigateToDashboard,
  onLogout,
}: UserDropdownMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-2 h-auto p-2">
          <Avatar className="h-8 w-8">
            <AvatarFallback className="text-sm">
              {(userDisplayName || user.email || 'U').charAt(0).toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <span className="hidden md:inline text-muted-foreground">
            {userDisplayName || user.email}
          </span>
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={onNavigateToProfile}>Profile</DropdownMenuItem>
        {!isAdmin && <DropdownMenuItem onClick={onNavigateToDashboard}>Dashboard</DropdownMenuItem>}
        {isAdmin && (
          <DropdownMenuItem onClick={onNavigateToDashboard}>Admin Dashboard</DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={onLogout}>Logout</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
